class AuctionAcceptanceType {
    constructor(serverType) {
        this.serverType = serverType;
    }

    translate(t) {
        return t(`auctions.acceptance-type.${this.serverType.toLowerCase().replace(/_/g, '-')}`);
    }

    is(auctionAcceptanceType) {
        return auctionAcceptanceType === this;
    }
}

export const AUTO = new AuctionAcceptanceType('AUTO');
export const MANUAL = new AuctionAcceptanceType('MANUAL');

export const getAuctionAcceptanceType = (serverType) => {
    let result = null;
    switch (serverType) {
        case 'AUTO':
            result = AUTO;
            break;
        case 'MANUAL':
            result = MANUAL;
            break;
        default:
            throw new Error(`Unknown auction acceptance type: ${serverType}`);
    }
    return result;
};

export const getAllAuctionAcceptanceTypes = () => [
    AUTO,
    MANUAL,
];
